import React, { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import './CountdownTimer.css';

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });
  const targetTimeRef = useRef(null);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  useEffect(() => {
    // Connect to Socket.IO to listen for payout events
    const socket = io(API_URL);
    
    // Listen for payout starting - reset timer when payout happens
    socket.on('payout:starting', () => {
      console.log('Payout starting - resetting timer');
      // Reset timer to next midnight UTC
      const now = new Date();
      targetTimeRef.current = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() + 1,
        0, 0, 0, 0
      ));
    });
    
    socket.on('payout:complete', (data) => {
      console.log('Payout complete:', data);
      // Reset timer for next payout (next midnight UTC)
      const now = new Date();
      targetTimeRef.current = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() + 1,
        0, 0, 0, 0
      ));
    });

    const calculateTimeLeft = () => {
      const now = new Date();
      
      // PRODUCTION: Count down to midnight UTC
      const targetTime = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() + 1,
        0, 0, 0, 0
      ));
      
      // Update targetTimeRef for Socket.IO resets
      if (!targetTimeRef.current || targetTimeRef.current.getTime() !== targetTime.getTime()) {
        targetTimeRef.current = targetTime;
      }
      
      const difference = targetTime.getTime() - now.getTime();
      
      if (difference > 0) {
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        
        setTimeLeft({ hours, minutes, seconds });
      } else {
        // If past target time, reset to 0
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
      }
    };

    // Calculate immediately
    calculateTimeLeft();

    // Update every second
    const interval = setInterval(() => {
      calculateTimeLeft();
    }, 1000);

    // Cleanup interval and socket on unmount
    return () => {
      if (interval) {
        clearInterval(interval);
      }
      socket.close();
    };
  }, [API_URL]);

  const formatTime = (value) => {
    return value.toString().padStart(2, '0');
  };

  return (
    <div className="countdown-timer win98-bevel">
      <div className="timer-header">
        <span className="timer-icon">🏆</span>
        <span className="timer-label">Next Winner Crowned In:</span>
      </div>
      <div className="timer-display">
        <div className="time-unit">
          <span className="time-value">{formatTime(timeLeft.hours)}</span>
          <span className="time-label">Hours</span>
        </div>
        <span className="time-separator">:</span>
        <div className="time-unit">
          <span className="time-value">{formatTime(timeLeft.minutes)}</span>
          <span className="time-label">Minutes</span>
        </div>
        <span className="time-separator">:</span>
        <div className="time-unit">
          <span className="time-value">{formatTime(timeLeft.seconds)}</span>
          <span className="time-label">Seconds</span>
        </div>
      </div>
      <div className="timer-footer">
        <span className="timer-note">⏰ UTC Midnight</span>
      </div>
    </div>
  );
};

export default CountdownTimer;

